var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCilChatBubbleGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cil:chat-bubble",
    clipPath: "url(#clip0_99_1559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.508 15.3323C18.7002 14.2698 19.3752 12.8536 19.3752 11.3839C19.3752 9.82207 18.644 8.36137 17.3163 7.27066C16.0241 6.20949 14.3138 5.625 12.5 5.625C10.6863 5.625 8.97586 6.20949 7.68387 7.27074C6.35617 8.36137 5.625 9.82207 5.625 11.3839C5.625 12.9458 6.35617 14.4065 7.68387 15.4972C8.97586 16.5585 10.6863 17.1429 12.5 17.1429C12.7417 17.1429 12.9848 17.1323 13.226 17.1111L13.6379 17.4681C15.0571 18.6979 16.8721 19.3749 18.75 19.375H19.375V18.0446L19.192 17.8616C18.4698 17.1374 17.8976 16.2779 17.508 15.3323ZM14.4566 16.5234L13.63 15.807L13.3544 15.8408C13.0709 15.8754 12.7856 15.8928 12.5 15.8929C9.39844 15.8929 6.875 13.8702 6.875 11.3839C6.875 8.89773 9.39844 6.875 12.5 6.875C15.6016 6.875 18.125 8.89769 18.125 11.3839C18.125 12.6226 17.507 13.779 16.3849 14.6401L16.025 14.9163L16.1911 15.3864C16.5314 16.3466 17.0317 17.2423 17.6708 18.0355C16.4807 17.8369 15.3685 17.3136 14.4566 16.5234Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.35098 12.4019C2.93603 11.6613 3.39538 10.8296 3.71066 9.94006L3.87551 9.47228L3.51586 9.19627C2.45773 8.38432 1.875 7.29455 1.875 6.12771C1.875 3.78303 4.25816 1.87549 7.1875 1.87549C9.3425 1.87549 11.2018 2.90791 12.0343 4.38721C12.1888 4.37971 12.3441 4.37549 12.5 4.37549C12.8132 4.37549 13.1235 4.39068 13.431 4.42107C13.1093 3.58768 12.5507 2.82689 11.7826 2.19603C10.5497 1.18326 8.91797 0.625488 7.1875 0.625488C5.45703 0.625488 3.82531 1.18326 2.59234 2.19603C1.32367 3.23818 0.625 4.63447 0.625 6.12771C0.625 7.52615 1.26375 8.87361 2.39258 9.88721C2.0242 10.7737 1.48592 11.5796 0.808086 12.2594L0.625 12.4425V13.7505H1.25C2.40575 13.7503 3.5456 13.4812 4.57934 12.9644C4.46598 12.5347 4.39957 12.0941 4.38125 11.6501C3.75382 12.0178 3.06659 12.2723 2.35098 12.4019Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_1559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilChatBubbleGrey);
export default __webpack_public_path__ + "static/media/cil_chat-bubble-Grey.56bc295bf3b22493b067ad0e4cc4f65d.svg";
export { ForwardRef as ReactComponent };